// Function to retrieve all contacts (JSON attempt)
var contactsarray = []

function getContactsData() {
  const request = window.indexedDB.open("ioScience", window.version)
  request.onsuccess = function() {
    const db = request.result
    const transaction = db.transaction("contactsQuery", "readwrite")
    const mapInfo = transaction.objectStore("contactsQuery")
    const all = mapInfo.getAll()

    all.onsuccess = function() {
      var contacts = all.result
      for (var i = 0; i < contacts.length; i++) {
        contactsarray.push(contacts[i].value)
      }
    }
  }
  return contactsarray
}

const Items = getContactsData()

const getContactById = key => {
  return key === undefined ? Items[0] : Items.find(x => x.key === key)
}

const getContact = limit => {
  return limit ? Items.slice(0, limit) : Items
}

export { Items, getContact, getContactById }
